import { render, staticRenderFns } from "./FloatWindow.vue?vue&type=template&id=6ffcf7e4&scoped=true"
import script from "./FloatWindow.vue?vue&type=script&lang=js"
export * from "./FloatWindow.vue?vue&type=script&lang=js"
import style0 from "./FloatWindow.vue?vue&type=style&index=0&id=6ffcf7e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffcf7e4",
  null
  
)

export default component.exports